import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/ux-fabric"

export type ContainerProps = {doRotate: boolean}
export const Container = styled("div", {
    shouldForwardProp: prop => prop !== "doRotate",
})<ContainerProps>`
    pointer-events: none;
    width: 1.5rem;
    height: 100%;
    display: flex;
    justify-content: left;
    align-items: center;
    transform: rotateY(${({doRotate}) => (doRotate ? "180deg" : "0")});
    z-index: 3;
    @media (min-width: ${breakpoints.values.md}px) {
        width: 2rem;
    }
    && button {
        pointer-events: auto;
        width: 1.5rem;
        border-radius: 0;
        height: 100%;
        padding: 0;
        span:first-of-type {
            width: auto;
        }
        background: ${({theme}) => theme.uxfabric.components.appBar.navBar.default.backgroundColor};
        @media (min-width: ${breakpoints.values.md}px) {
            width: 2rem;
        }
    }
`
